import { Tag, Tooltip } from 'antd';

import useLocale from '../../../hooks/useLocale';
import type { IStatusPresentation } from './types';

interface IProps {
  presentation?: IStatusPresentation;
  label: string;
}

const StatusTag = ({ presentation, label }: IProps): JSX.Element => {
  const { t } = useLocale();

  return (
    <Tooltip title={presentation && t[presentation.meaningKey]}>
      <Tag color={presentation?.color}>{label}</Tag>
    </Tooltip>
  );
};

export default StatusTag;
